import './TestOrderListScreen.scss';
import React, {useCallback, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {CommonService} from '../../../shared/services';
import AddIcon from '@mui/icons-material/Add';
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import TestOrderListTableComponent from './test-order-list-table/TestOrderListTableComponent';
import {Download} from "@mui/icons-material";
import {IAPIResponseType} from "../../../shared/models/api.model";
import DrawerComponent from "../../../shared/components/drawer/drawerComponent";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import TestOrderFiltersComponent from "../test-order-filters/TestOrderFiltersComponent";
import ReorderIcon from '@mui/icons-material/Reorder';
import {useDispatch, useSelector} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import {IRootReducerState} from "../../../store/reducers";
import _ from "lodash";
import SearchComponent from "../../../shared/components/search/SearchComponent";
import commonService from "../../../shared/services/common.service";

const FiltersInitialState: any = {
    search: '',
    facilityObjs: [],
    facilityIds: [],
    locationObjs: [],
    locationIds: [],
    physicianIds: [],
    physicianObjs: [],
    statuses: [],
    statusesObjs: [],
    startDate: '',
    endDate: ''
}

const showBulkUpload=true;//Todo: Remove this static variable

const FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS = ['statusesObjs', 'facilityObjs', 'locationObjs', 'physicianObjs'];

const TestOrderListScreen = () => {

    const [isCSVDownloading, setIsCSVDownloading] = useState(false);
    const [showFilterDrawer, setShowFiltersDrawer] = useState<boolean>(false);
    const dispatch = useDispatch();
    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
    const {
        facilityListLite,
        physicianListLite,
        testOrderStatusList,
        locationListLite
    } = useSelector((state: IRootReducerState) => state.staticData);
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);


    useEffect(() => {
        dispatch(setCurrentNavParams("Test Order", "Test Order"));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    const downloadCSV = useCallback(() => {
        const payload = {...filterData};
        setIsCSVDownloading(true);
        CommonService._testOrder.downloadTestOrderCSV(payload)
            .then((response: IAPIResponseType<any>) => {
                setIsCSVDownloading(false);
                if (response && response?.data && response?.data?.attachmentUrl) {
                    CommonService.downloadFile(response?.data?.attachmentUrl, response?.data?.title || 'testOrderList', 'csv');
                }
            })
            .catch((error: any) => {
                setIsCSVDownloading(false);
            });
    }, [filterData]);

    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
    }, []);


    useEffect(() => {
        if (queryParamData) {
            const data: any = {
                search: queryParamData.search || '',
                startDate: queryParamData.startDate || '',
                endDate: queryParamData.endDate || '',
            };
            if (queryParamData?.statuses?.length) {
                data['statuses'] = queryParamData.statuses.split(',') || [];
            }
            data['statusesObjs'] = testOrderStatusList.filter((item: any) => data['statuses']?.includes(item?.code));

            if (queryParamData?.facilityIds?.length) {
                data['facilityIds'] = queryParamData.facilityIds.split(',') || [];
            }
            data['facilityObjs'] = facilityListLite.filter((item: any) => data['facilityIds']?.includes(item?.id?.toString()));

            if (queryParamData?.locationIds?.length) {
                data['locationIds'] = queryParamData.locationIds.split(',') || [];
            }
            data['locationObjs'] = locationListLite.filter((item: any) => data['locationIds']?.includes(item?.id?.toString()));

            if (queryParamData?.physicianIds?.length) {
                data['physicianIds'] = queryParamData.physicianIds.split(',') || [];
            }
            data['physicianObjs'] = physicianListLite.filter((item: any) => data['physicianIds']?.includes(item?.id?.toString()));

            setFilterData((prevState: any) => ({
                ...prevState, ...data
            }));
        }
    }, [queryParamData, testOrderStatusList, facilityListLite, locationListLite, physicianListLite]);

    const applyFilters = useCallback((filterData: any) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            ...filterData
        }));
        setShowFiltersDrawer(false);
    }, []);

    useEffect(() => {
        CommonService.mapFilterDataToQueryParams(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS);
    }, [filterData]);

    const clearAllFilters = useCallback(() => {
        setFilterData(_.cloneDeep(FiltersInitialState));
    }, []);

    return (
        <div className="test-order-list-screen screen">
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search"}
                                id="search_input"
                                placeholder={"Search using order ID or patient name"}
                                value={filterData.search}
                                onChange={handleSearch}
                            />
                        </div>
                        <div className="page-extra-options">
                            {
                                CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 &&
                                <ButtonComponent
                                    type="button"
                                    id="clear_all_filters"
                                    color={"secondary"}
                                    variant={"text"}
                                    fullWidth={false}
                                    handleClick={clearAllFilters}
                                >
                                    Clear All
                                </ButtonComponent>
                            }
                            <ButtonComponent
                                type="button"
                                id="csv_btn"
                                color={"primary"}
                                variant={"outlined"}
                                fullWidth={false}
                                handleClick={() => setShowFiltersDrawer(true)}
                                startIcon={<FilterAltIcon/>}>
                                Filters {CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 ? `( ${CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS)} )` : ''}
                            </ButtonComponent>
                            {
                                showBulkUpload && commonService.checkAccess('TestOrder','testOrderBulkList',currentUser?.userAccessModules) &&
                                <Link to={CommonService._routeConfig.BulkOrderListRoute()}>
                                    <ButtonComponent
                                        type="button"
                                        id="bulk_test_order_btn"
                                        color={"primary"}
                                        variant={"outlined"}
                                        fullWidth={false}
                                        startIcon={<ReorderIcon/>}
                                    >
                                        Bulk Test Order
                                    </ButtonComponent>
                                </Link>
                            }
                            {
                                commonService.checkAccess('TestOrder','testOrderCsvDownload',currentUser?.userAccessModules) &&
                                <ButtonComponent
                                    type="button"
                                    id="csv_btn"
                                    color={"secondary"}
                                    variant={"outlined"}
                                    fullWidth={false}
                                    handleClick={downloadCSV}
                                    isLoading={isCSVDownloading}
                                    disabled={isCSVDownloading}
                                    startIcon={<Download/>}
                                >
                                    CSV
                                </ButtonComponent>
                            }
                            {
                                commonService.checkAccess('TestOrder','testOrderAdd',currentUser?.userAccessModules) &&
                                <Link to={CommonService._routeConfig.TestOrderCreateRoute()}>
                                    <ButtonComponent
                                        type="button"
                                        color={"primary"}
                                        variant={"contained"}
                                        id="add_test_order_btn"
                                        startIcon={<AddIcon/>}
                                    >
                                        New Test Order
                                    </ButtonComponent>
                                </Link>
                            }
                        </div>
                    </div>
                    <>
                        <TestOrderListTableComponent
                            isColumnFilterVisible={true}
                            filterData={filterData}
                        />
                    </>
                </div>
            </div>

            <DrawerComponent open={showFilterDrawer}
                             className={"drawer-wrapper"}
                             closeOnBackDropClick={true}
                             closeOnEsc={true}
                             onClose={() => setShowFiltersDrawer(false)}
            >
                <TestOrderFiltersComponent filtersData={filterData} onFiltersApply={applyFilters} clearAllFilters={clearAllFilters}/>
            </DrawerComponent>
        </div>
    )
}

export default TestOrderListScreen;
